import { render, staticRenderFns } from "./RequestTypeEdit.vue?vue&type=template&id=9a64b344"
import script from "./RequestTypeEdit.vue?vue&type=script&lang=js"
export * from "./RequestTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports